import React from "react";
import styles from "../stylesERv2.module.scss";

/**
 * Detalle de la facturación (ventas) que compone la celda de un mes de la fila
 * "A - Publicidad" del ER v2. Solo lectura, mismo molde simple que el `InvoiceModal`
 * del v1 (columnas de venta: Factura / Cliente / Importe, mismo manejo de `moneda_dolar`),
 * pero con el maquetado del ER v2 (overlay + modalContent + modalTable).
 *
 * Las facturas llegan YA combinadas (pauta `facturasPorMes` + contratos
 * `facturasPorMesContratos`) y filtradas por mes desde `index.js`; acá no hay lógica de
 * datos. El total al pie es la suma de los mismos importes → cuadra con la celda por
 * construcción. Aplica a Chile y Perú (solo se abre en país único, no combinado/LTM).
 */
export const DetalleFacturacionModal = ({ isOpen, mes, facturas = [], formatCurrency, pais, onClose }) => {
  if (!isOpen) return null;

  const total = facturas.reduce((sum, f) => sum + (f.importe || 0), 0);

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3>Detalle facturación — {mes}</h3>

        {facturas.length === 0 ? (
          <p style={{ margin: "16px 0", color: "#666", fontSize: "0.9rem" }}>No hay facturación en este mes.</p>
        ) : (
          <table className={styles.modalTable}>
            <thead>
              <tr>
                <th style={{ textAlign: "left" }}>Factura</th>
                <th style={{ textAlign: "left" }}>Cliente</th>
                <th style={{ textAlign: "end" }}>Importe</th>
              </tr>
            </thead>
            <tbody>
              {facturas.map((f, i) => {
                // Mismo manejo de moneda_dolar que el InvoiceModal del v1: en dólares se
                // muestra el importe original en USD; si no, el importe en moneda local.
                const usd = (f.importeOriginalMoneda || 0).toLocaleString(pais === "Chile" ? "es-CL" : "es-PE", {
                  maximumFractionDigits: 0,
                });
                const importeStr = f.moneda_dolar ? `US$ ${usd}` : formatCurrency(f.importe);
                return (
                  <tr key={`${f.facturanumero}-${i}`}>
                    <td style={{ textAlign: "left" }}>{f.facturanumero}</td>
                    <td style={{ textAlign: "left" }}>{f.cliente}</td>
                    <td style={{ textAlign: "end" }}>{importeStr}</td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={2} style={{ textAlign: "end", fontWeight: 600 }}>
                  Total
                </td>
                <td style={{ textAlign: "end", fontWeight: 600 }}>{formatCurrency(total)}</td>
              </tr>
            </tfoot>
          </table>
        )}

        <div className={styles.modalActions}>
          <button className={styles.btnClose} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
